var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { STACK_ALIGN, STACK_DIRECTION, STACK_DISTRIBUTION, STACK_GAP, StackView } from "../StackView";
import { Text, TEXT_SIZE, TEXT_VIEW } from "../Text";
import { INDENT, SPACE_FILL, View, VIEW_ALIGN } from "../View";
import { Tile } from './Tile';
import { SCHEDULING_MATRIX_COLUMN_TIME_PRESET } from './timeHeader';
import { SCHEDULING_MATRIX_TILE_SIZE } from './types';
import { ColumnHeader, TopLegend, TopLegendHeader } from './TopLegend';
import { defaultIsSelected } from './defaultIsSelected';
import { useWillSelect } from './useWillSelect';
import { createUIElement, SIZE_L, useStateValue, SIZE_XL } from "../helpers";
import { getColumnCellsSelected, getRowCellsSelected, isAllColumnSelected, isAllRowSelected } from './helpers';
export var SCHEDULING_MATRIX_SELECT_MOD;
(function (SCHEDULING_MATRIX_SELECT_MOD) {
    SCHEDULING_MATRIX_SELECT_MOD["select"] = "select";
    SCHEDULING_MATRIX_SELECT_MOD["unselect"] = "unselect";
    SCHEDULING_MATRIX_SELECT_MOD["auto"] = "auto";
})(SCHEDULING_MATRIX_SELECT_MOD || (SCHEDULING_MATRIX_SELECT_MOD = {}));
var Row = styled(StackView)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    height: ", ";\n"], ["\n    height: ", ";\n"])), SIZE_L);
var RowHeader = styled(Row)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    height: ", ";\n"], ["\n    height: ", ";\n"])), SIZE_XL);
var FooterContentRow = styled(Row)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding-top: ", "px;\n"], ["\n    padding-top: ", "px;\n"])), 32 - 4);
var TileArea = styled(View)(templateObject_4 || (templateObject_4 = __makeTemplateObject([""], [""])));
var MatrixTiles = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject([""], [""])));
var TopSelection = styled(View)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    position: absolute;\n    top: 0;\n    left: 4px;\n    right: 4px;\n    bottom: 0;\n    background-color: ", ";\n"], ["\n    position: absolute;\n    top: 0;\n    left: 4px;\n    right: 4px;\n    bottom: 0;\n    background-color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colorHighlightLight;
});
var LeftSelection = styled(View)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    position: absolute;\n    top: 0;\n    left: -8px;\n    right: 0;\n    bottom: 0;\n    background-color: ", ";\n"], ["\n    position: absolute;\n    top: 0;\n    left: -8px;\n    right: 0;\n    bottom: 0;\n    background-color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colorHighlightLight;
});
var Root = styled(StackView)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    user-select: none;\n    padding-top: ", ";\n"], ["\n    user-select: none;\n    padding-top: ",
    ";\n"])), function (_a) {
    var hasLegendHeader = _a.hasLegendHeader;
    return hasLegendHeader ? 24 + 4 + 16 + 8 + "px" : 24 + 4 + "px";
});
var SchedulingMatrixBase = createUIElement('SchedulingMatrix', function (_a, ref) {
    var className = _a.className, rows = _a.rows, columns = _a.columns, data = _a.data, mode = _a.mode, onSelect = _a.onSelect, footer = _a.footer, _b = _a.tileSize, tileSize = _b === void 0 ? SCHEDULING_MATRIX_TILE_SIZE.m : _b, _c = _a.isSelected, isSelected = _c === void 0 ? defaultIsSelected : _c, isDisabled = _a.isDisabled, legendHeader = _a.legendHeader, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "rows", "columns", "data", "mode", "onSelect", "footer", "tileSize", "isSelected", "isDisabled", "legendHeader", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    var _d = useState(null), startSelectValue = _d[0], setStartSelectValue = _d[1];
    var _e = useState(null), hoverValue = _e[0], setHoverValue = _e[1];
    var _f = useWillSelect(), setWillSelect = _f.setWillSelect, removeWillSelect = _f.removeWillSelect, removeAllWillSelect = _f.removeAllWillSelect, isSomeInRowWillSelect = _f.isSomeInRowWillSelect, isSomeInColumnWillSelect = _f.isSomeInColumnWillSelect, isWillSelected = _f.isWillSelected, getAllWillSelected = _f.getAllWillSelected;
    var isAutoMode = mode === SCHEDULING_MATRIX_SELECT_MOD.auto;
    var modeState = useStateValue(mode === SCHEDULING_MATRIX_SELECT_MOD.auto ? SCHEDULING_MATRIX_SELECT_MOD.select : mode, [mode]);
    var startSelect = function (rowIndex, columnIndex) {
        setStartSelectValue({ rowIndex: rowIndex, columnIndex: columnIndex });
    };
    var endSelect = function () {
        setStartSelectValue(null);
        removeAllWillSelect();
    };
    var clickRowHeaderHandler = function (rowIndex) {
        var nextSelectedValue = isAutoMode
            ? !isAllRowSelected({
                rowIndex: rowIndex,
                isSelected: isSelected,
                columns: columns,
                rows: rows,
                data: data
            })
            : modeState.getValue() === SCHEDULING_MATRIX_SELECT_MOD.select;
        onSelect === null || onSelect === void 0 ? void 0 : onSelect(getRowCellsSelected({
            rowIndex: rowIndex,
            columns: columns,
            rows: rows
        }), nextSelectedValue);
    };
    var clickColumnHeaderHandler = function (columnIndex) {
        var nextSelectedValue = isAutoMode
            ? !isAllColumnSelected({
                columnIndex: columnIndex,
                isSelected: isSelected,
                columns: columns,
                rows: rows,
                data: data
            })
            : modeState.getValue() === SCHEDULING_MATRIX_SELECT_MOD.select;
        onSelect === null || onSelect === void 0 ? void 0 : onSelect(getColumnCellsSelected({
            columnIndex: columnIndex,
            columns: columns,
            rows: rows
        }), nextSelectedValue);
    };
    var clickTileAreaHandler = function (_a) {
        var disabled = _a.disabled, rowIndex = _a.rowIndex, columnIndex = _a.columnIndex, rowKey = _a.rowKey, columnKey = _a.columnKey;
        if (disabled) {
            return;
        }
        var nextSelectedValue = modeState.getValue() === SCHEDULING_MATRIX_SELECT_MOD.select;
        onSelect === null || onSelect === void 0 ? void 0 : onSelect([
            {
                rowIndex: rowIndex,
                columnIndex: columnIndex,
                rowKey: rowKey,
                columnKey: columnKey
            }
        ], nextSelectedValue);
        if (isAutoMode) {
            modeState.setValue(nextSelectedValue
                ? SCHEDULING_MATRIX_SELECT_MOD.unselect
                : SCHEDULING_MATRIX_SELECT_MOD.select);
        }
    };
    var mouseDownTileAreaHandler = function (_a) {
        var disabled = _a.disabled, rowIndex = _a.rowIndex, columnIndex = _a.columnIndex;
        if (disabled) {
            return;
        }
        startSelect(rowIndex, columnIndex);
    };
    var mouseEnterTileAreaHandler = function (_a) {
        var rowIndex = _a.rowIndex, columnIndex = _a.columnIndex, rowKey = _a.rowKey, columnKey = _a.columnKey;
        setWillSelect({ rowIndex: rowIndex, columnIndex: columnIndex }, startSelectValue);
        var selected = isSelected({
            rowIndex: rowIndex,
            columnIndex: columnIndex,
            data: data,
            rowKey: rowKey,
            columnKey: columnKey
        });
        setHoverValue({ rowIndex: rowIndex, columnIndex: columnIndex });
        if (!startSelectValue && isAutoMode) {
            modeState.setValue(selected
                ? SCHEDULING_MATRIX_SELECT_MOD.unselect
                : SCHEDULING_MATRIX_SELECT_MOD.select);
        }
    };
    var mouseLeaveTileAreaHandler = function (_a) {
        var rowIndex = _a.rowIndex, columnIndex = _a.columnIndex;
        if (startSelectValue) {
            return;
        }
        removeWillSelect({ rowIndex: rowIndex, columnIndex: columnIndex });
    };
    var mouseLeaveMatrixTiles = function () {
        setHoverValue(null);
    };
    var isSelectedRowHeader = function (rowIndex) {
        return (hoverValue === null || hoverValue === void 0 ? void 0 : hoverValue.rowIndex) === rowIndex || isSomeInRowWillSelect(rowIndex);
    };
    var isSelectedColumnHeader = function (columnIndex) {
        return (hoverValue === null || hoverValue === void 0 ? void 0 : hoverValue.columnIndex) === columnIndex || isSomeInColumnWillSelect(columnIndex);
    };
    var hasLegendHeader = !!legendHeader;
    useEffect(function () {
        var cb = function () {
            var items = getAllWillSelected()
                .map(function (_a) {
                var columnIndex = _a.columnIndex, rowIndex = _a.rowIndex;
                var disabled = isDisabled === null || isDisabled === void 0 ? void 0 : isDisabled({
                    rowIndex: rowIndex,
                    columnIndex: columnIndex,
                    data: data,
                    rowKey: rows[rowIndex].key,
                    columnKey: columns[columnIndex].key
                });
                if (disabled) {
                    return null;
                }
                return {
                    rowIndex: rowIndex,
                    columnIndex: columnIndex,
                    rowKey: rows[rowIndex].key,
                    columnKey: columns[columnIndex].key
                };
            })
                .filter(Boolean);
            var nextSelectedValue = modeState.getValue() === SCHEDULING_MATRIX_SELECT_MOD.select;
            if (items.length > 1) {
                onSelect === null || onSelect === void 0 ? void 0 : onSelect(items, nextSelectedValue);
            }
            endSelect();
        };
        document.addEventListener('mouseup', cb);
        return function () {
            document.removeEventListener('mouseup', cb);
        };
    }, [onSelect]);
    return (React.createElement(Root, __assign({}, rest, { "data-selector-id": rest['data-selector-id'], className: "vm-SchedulingMatrix " + className, hasLegendHeader: hasLegendHeader, direction: STACK_DIRECTION.row, gap: STACK_GAP.xs, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }),
        React.createElement(StackView, { direction: STACK_DIRECTION.column },
            rows.map(function (row, rowIndex) { return (React.createElement(RowHeader, { key: rowIndex, direction: STACK_DIRECTION.row, align: STACK_ALIGN.center, root: true, spaceVertical: INDENT.xs, onClick: function () { return clickRowHeaderHandler(rowIndex); } },
                React.createElement(View, { spaceFill: SPACE_FILL.all, align: VIEW_ALIGN.center, spaceRight: INDENT.xl, root: true },
                    isSelectedRowHeader(rowIndex) && React.createElement(LeftSelection, null),
                    React.createElement(Text, null, row.title)))); }),
            footer && (React.createElement(Row, { key: 'footer', direction: STACK_DIRECTION.row, align: STACK_ALIGN.center, indentTop: INDENT.xs, spaceTop: INDENT.l },
                React.createElement(Text, null, footer.title)))),
        React.createElement(StackView, { direction: STACK_DIRECTION.column, root: true },
            React.createElement(MatrixTiles, { onMouseLeave: mouseLeaveMatrixTiles }, rows.map(function (row, rowIndex) { return (React.createElement(StackView, { key: rowIndex, direction: STACK_DIRECTION.row }, columns.map(function (col, columnIndex) {
                var selected = isSelected({
                    rowIndex: rowIndex,
                    columnIndex: columnIndex,
                    data: data,
                    rowKey: row.key,
                    columnKey: col.key
                });
                var disabled = isDisabled === null || isDisabled === void 0 ? void 0 : isDisabled({
                    rowIndex: rowIndex,
                    columnIndex: columnIndex,
                    data: data,
                    rowKey: row.key,
                    columnKey: col.key
                });
                return (React.createElement(TileArea, { key: columnIndex, spaceHorizontal: INDENT.xs, spaceVertical: INDENT.xs, onMouseDown: function () {
                        mouseDownTileAreaHandler({
                            disabled: disabled,
                            rowIndex: rowIndex,
                            columnIndex: columnIndex
                        });
                    }, onMouseEnter: function () {
                        mouseEnterTileAreaHandler({
                            rowIndex: rowIndex,
                            columnIndex: columnIndex,
                            rowKey: row.key,
                            columnKey: col.key
                        });
                    }, onMouseLeave: function () {
                        mouseLeaveTileAreaHandler({ rowIndex: rowIndex, columnIndex: columnIndex });
                    }, onClick: function () {
                        return clickTileAreaHandler({
                            disabled: disabled,
                            rowIndex: rowIndex,
                            columnIndex: columnIndex,
                            rowKey: row.key,
                            columnKey: col.key
                        });
                    } },
                    React.createElement(Tile, { size: tileSize, key: columnIndex, willSelect: isWillSelected({ rowIndex: rowIndex, columnIndex: columnIndex }), selected: selected, disabled: disabled })));
            }))); })),
            footer && (React.createElement(FooterContentRow, { key: 'footer', direction: STACK_DIRECTION.row, align: STACK_ALIGN.center, spaceLeft: INDENT.xs },
                React.createElement(Text, null, footer.render()))),
            React.createElement(TopLegend, { tileSize: tileSize, align: STACK_ALIGN.fill, spaceLeft: INDENT.xs }, columns.map(function (col, columnIndex) { return (React.createElement(ColumnHeader, { key: columnIndex, direction: STACK_DIRECTION.row, distribution: STACK_DISTRIBUTION.center }, isSelectedColumnHeader(columnIndex) && React.createElement(TopSelection, null))); })),
            React.createElement(TopLegend, { tileSize: tileSize, spaceLeft: INDENT.xs }, columns.map(function (col, columnIndex) { return (React.createElement(ColumnHeader, { key: columnIndex, direction: STACK_DIRECTION.row, distribution: STACK_DISTRIBUTION.center, align: STACK_ALIGN.center, onClick: function () { return clickColumnHeaderHandler(columnIndex); } }, col.renderCel ? col.renderCel() : React.createElement(Text, null, col.title || ''))); })),
            hasLegendHeader && (React.createElement(TopLegendHeader, { sideOffset: (legendHeader === null || legendHeader === void 0 ? void 0 : legendHeader.sideOffset) || 0 }, legendHeader === null || legendHeader === void 0 ? void 0 : legendHeader.render()))),
        React.createElement(StackView, { direction: STACK_DIRECTION.column, gap: STACK_GAP.s, spaceTop: INDENT.xs, indentRight: INDENT.xl, indentLeft: INDENT.m }, rows.map(function (row, rowIndex) { return (React.createElement(Row, { key: rowIndex, direction: STACK_DIRECTION.row, align: STACK_ALIGN.center },
            React.createElement(Text, { size: TEXT_SIZE.s, view: TEXT_VIEW.secondary }, typeof row.description === 'function'
                ? row.description({ data: data, rowIndex: rowIndex, rowKey: row.key })
                : row.description))); }))));
});
export var SchedulingMatrix = Object.assign({}, SchedulingMatrixBase, {
    modes: SCHEDULING_MATRIX_SELECT_MOD,
    tileSizes: SCHEDULING_MATRIX_TILE_SIZE,
    columnPresets: {
        timeRange: SCHEDULING_MATRIX_COLUMN_TIME_PRESET
    }
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
//# sourceMappingURL=SchedulingMatrix.js.map